// Generated types for Standard
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { InterfaceCategory } from '../enums';

import { CatalogNodeReadAPI, CatalogNodeWriteAPI } from '../../shared/types/catalognode';
import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { CatalogNodeReadAPISchemaObject, CatalogNodeWriteAPISchemaObject } from '../../shared/types/catalognode';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface StandardReadAPI extends CatalogNodeReadAPI, RFLPElementReadAPI {
  /** Which kind of interface this standard describes. */
  category: InterfaceCategory;
  /** Link to authoritative specification document (ISO, USB-IF, etc.). */
  specification_url?: string | null;
}

export interface StandardWriteAPI extends CatalogNodeWriteAPI, RFLPElementWriteAPI {
  /** Which kind of interface this standard describes. */
  category: InterfaceCategory;
  /** Link to authoritative specification document (ISO, USB-IF, etc.). */
  specification_url?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const StandardReadAPISchema: z.ZodType<StandardReadAPI> = CatalogNodeReadAPISchemaObject.extend(RFLPElementReadAPISchemaObject.shape).extend({
  category: z.nativeEnum(InterfaceCategory),
  specification_url: z.string().nullable().optional(),
}).passthrough();

export const StandardWriteAPISchema: z.ZodType<StandardWriteAPI> = CatalogNodeWriteAPISchemaObject.extend(RFLPElementWriteAPISchemaObject.shape).extend({
  category: z.nativeEnum(InterfaceCategory),
  specification_url: z.string().nullable().optional(),
}).passthrough();
